<template>
<section v-if="bg" :style="'background-image: url(' + bg.image.url + ');'" :class="[block.class, 'has-text-centered hero is-' + bg.config.height, 'attachment-' + bg.config.attachment]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div :class="['hero-body', {'is-tinty': bg.config.tinty}]">
        <div class="container" :style="'opacity: ' + opacity">
            <h1 ref="title" :class="['title', {'sr-only': block.hide_title}]">{{block.title}}</h1>
            <p v-if="block.content" class="subtitle" ref="content" v-html="block.content"></p>
        </div>
        <div class="image-copyright has-text-white" v-if="copyright" v-html="copyright"></div>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
export default {
    name        :   'ClassicPageHeroBlock',
    mixins      :   [ BlockCommons ],
    data()
    {
        return {
            opacity     :   1,
            font_size   :   48
        };
    },
    computed    :   {
        bg()
        {
            if (this.block && this.block.background.image.url) {
                return this.block.background;
            }
            return null;
        },
        copyright()
        {
            if (this.block && this.block.background && this.block.background.image) {
                return this.block.background.image.copyright;
            }
            return null;
        }
    },
    mounted()
    {
        this.$bus.$on('onWindowScroll', this.handle_text_fade);
        this.$nextTick().then(() => {
            $(window).scroll().resize();
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        });
    },
    beforeDestroy()
    {
        this.$bus.$off('onWindowScroll', this.handle_text_fade);
    },
    methods     :   {
        handle_text_fade(offset)
        {
            if (!this.block.background.config.text_fade) return false;
            if (offset == 0) {
                this.opacity    =   1;
                return false;
            }
            let n   =   100 - ($(this.$refs.title).offset().top - offset);
            this.opacity    -=   n * 0.001;
            if (this.opacity > 1) {
                this.opacity    =   1;
            } else if (this.opacity < 0) {
                this.opacity    =   0;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/ClassicPageHeroBlock.vue